const DOM_NODES = {
  DIV: 'div',
  P: 'p',
  STRONG: 'strong',
  EM: 'em',
  I: 'i',
  UL: 'ul',
  OL: 'ol',
  LI: 'li',
  H2: 'H2',
  H3: 'H3',
  H4: 'H4',
  H5: 'H5',
  FIGURE: 'figure',
  IMG: 'img',
  A: 'a'
};

export default DOM_NODES;



// WEBPACK FOOTER //
// ./src/common/consts/domNodes.js